import httpService from '@/services/httpService'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import Dashboard from '../../../features/dashboard/index.vue'

export const types = {
  ADD_DASHBOARD_ACTION: 'rank-zone/ADD_DASHBOARD_ACTION',
  ADD_DASHBOARD_URLS: 'rank-zone/ADD_DASHBOARD_URLS',
  ADD_DASHBOARD_RESET: 'rank-zone/ADD_DASHBOARD_RESET'
}
const emptyData = {
  events: [],
  urls: []
}

const state = { ...emptyData }

const mutations = {
  [ types.ADD_DASHBOARD_ACTION ]: function (state, events) {
    state.events = events || []
  },
  [ types.ADD_DASHBOARD_URLS ]: function (state, urls) {
    state.urls = urls
  },
  [ types.ADD_DASHBOARD_RESET ]: function (state) {
    state = { ...emptyData }
  }
}

const actions = {

  getCalendar: async function ({ commit, dispatch }, { clientId }) {
    const params = { date_from: moment(new Date()).format() }
    const response = await httpService.get(`/calendar/dashboard/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_DASHBOARD_ACTION, response.data.events)
      return response.data.events
    }
  },
  changeEvent: function ({ commit }, { clientId, eventId, date, type }) {
    const params = { event_id: eventId, date, type }
    return httpService.patch(`/calendar/change-event/${clientId}`, params, { successMessage: 'Event updated successfully' })
  },
  resetData: function ({ commit }) {
    commit(types.ADD_CALENDAR_SESSION, emptyData)
  }
}
/**
 * Store keep data for {@link Dashboard} component
 * This one is absent in final version of the application and may be in demand in the future
 * */

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
